import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { visuallyHidden } from '@mui/utils';
import { Button, Card, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, IconButton, InputLabel, LinearProgress, List, ListItem, ListItemText, MenuItem, Select, Switch, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDomainImportLogs } from '../../store/domainSlice';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CommentDrawer from '../Common/Drawer';
import { ROWS_PER_PAGE } from '../../utils/constant';
import { formatDate } from '../../utils/helper';
import Confirmation from '../Common/Confirmation';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { AccessTime, Cancel, CheckCircle, CloseRounded, PlayCircleFilled, Stop } from '@mui/icons-material';
import { useEffect } from 'react';
import BasicPopover from '../Common/PopOver';
import { NoData } from '../Common/NoData';
import { alpha } from '@mui/material/styles';
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ViewMorePopover from '../Common/ReadMoreLess';
import BackupTableIcon from '@mui/icons-material/BackupTable';

function createData(id, fileName, uploadedFile, status, importedAt, completedAt, actions) {
    return {
        id,
        fileName,
        uploadedFile,
        status,
        importedAt,
        completedAt,
        actions
    };
}

const DomainLogActions = ({ domainLog, theme, setSelectedDomainLogLog, setDomainLogLogModal, canDelete, canEdit }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [openPreview, setOpenPreview] = React.useState(false);
    const dispatch = useDispatch()
    const locationsString = domainLog?.locations?.map((loc) => loc.display_name).join(', ');
    const handleDelete = async (id) => {
    }

    return (
        <>
            <Grid spacing={4} justifyContent={'flex-end'}>
                <Grid size={8}>
                    <CommentDrawer width="40%" {...{ open, setOpen }} >
                        <Box className="p-3">
                            <Typography variant="h6" gutterBottom>
                                Log Detail
                            </Typography>
                            <Divider />

                            <div className='role-form-scroller mt-3'>
                                <TableContainer className='position-relative'>
                                    <Table

                                        size={'small'}
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    className="font-weight"
                                                    key="Row Number"
                                                    align="center"
                                                    padding="normal"
                                                >
                                                    Row No.
                                                </TableCell>
                                                <TableCell
                                                    className="font-weight"
                                                    key="Description"
                                                    align="left"
                                                    padding="normal"
                                                >
                                                    Description
                                                </TableCell>
                                                <TableCell
                                                    className="font-weight"
                                                    key="status"
                                                    align="left"
                                                    padding="normal"
                                                >
                                                    Status
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {domainLog?.row_logs?.map((row, index) => {
                                                const color = theme.palette.custom?.[row?.status];
                                                const bgColor = theme.palette.custom?.[`${row?.status}Background`];
                                                const borderColor = theme.palette.custom?.[`${row?.status}Border`];

                                                return (
                                                    <TableRow>
                                                        <TableCell
                                                            className="font-weight"
                                                            key="Row Number"
                                                            align="center"
                                                            padding="normal"
                                                        >
                                                            {row?.row_number}
                                                        </TableCell>
                                                        <TableCell
                                                            className="font-weight"
                                                            key="Description"
                                                            align="left"
                                                            padding="normal"
                                                        >
                                                            {row?.reason}
                                                        </TableCell>
                                                        <TableCell
                                                            className="font-weight"
                                                            key="status"
                                                            align="left"
                                                            padding="normal"
                                                        >
                                                            <Button
                                                                size="small"
                                                                sx={{
                                                                    color: color || 'inherit',
                                                                    backgroundColor: bgColor ? alpha(bgColor, 0.1) : 'transparent',
                                                                    borderColor: borderColor || 'grey.300',
                                                                    textTransform: 'capitalize',
                                                                }}

                                                                variant="outlined"
                                                            >
                                                                {statusIcons[row?.status]}
                                                                {row?.status}
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                    {!domainLog?.row_logs?.length && <NoData></NoData>}
                                </TableContainer>

                            </div>
                        </Box>
                        <Box className="drawer-footer m-3">
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                onClick={() => setOpen(false)}
                                className="mt-2 mr-2"
                            >
                                close
                            </Button>
                        </Box>
                    </CommentDrawer>
                    <Box gap={2} display='flex' className="table-margin">
                        <Tooltip title="Preview File" arrow>
                            <RemoveRedEyeOutlinedIcon className='link-color' onClick={() => {
                                setOpenPreview(true);
                            }} />
                        </Tooltip>
                        <Tooltip title="Preview Logs" arrow>
                            <ListAltIcon className='link-color' onClick={() => {
                                setOpen(true);
                            }} />
                        </Tooltip>
                        <Dialog
                            PaperProps={{
                                style: {
                                    height: 500,
                                }
                            }}
                            open={openPreview} onClose={() => setOpenPreview(false)} fullWidth maxWidth="lg">
                            <DialogTitle>File Preview</DialogTitle>
                            <DialogContent dividers>
                                <TableContainer className='position-relative'>
                                    <Table
                                        className='min-width-750'
                                        aria-labelledby="tableTitle"
                                        size={'small'}
                                    >
                                        <TableHead>
                                            <TableRow>
                                                {domainLog?.columns?.length && domainLog.columns?.map((headCells) => (

                                                    <TableCell
                                                        className="font-weight"
                                                        key={headCells}
                                                        align={"left"}
                                                        padding="normal"
                                                        style={{ textTransform: "capitalize" }}
                                                    >
                                                        {headCells}
                                                    </TableCell>
                                                ))}


                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                            {domainLog?.row_logs?.length ?
                                                domainLog?.row_logs?.map((row, index) => {
                                                    const labelId = `enhanced-table-checkbox-${index}`;
                                                    return (
                                                        <TableRow
                                                            hover
                                                            role="checkbox"
                                                            tabIndex={-1}
                                                            key={row.id}
                                                            id={labelId}
                                                            className='cursor-pointer'
                                                        >
                                                            {domainLog?.columns?.length && domainLog?.columns.map((col, ind) => {
                                                                const colCount = domainLog?.columns?.length;
                                                                const maxLength = colCount === 2 ? 70 : colCount === 3 ? 40 : colCount === 4 ? 30 : 20;
                                                                const value = row?.row_data[col];

                                                                return (
                                                                    <TableCell align="left" key={ind}>
                                                                        {value ? value.slice(0, maxLength) : "N/A"}
                                                                        {value && value.length > maxLength && (
                                                                            <ViewMorePopover>
                                                                                <div>{value}</div>
                                                                            </ViewMorePopover>
                                                                        )}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                        </TableRow>
                                                    );
                                                }) : <></>
                                            }
                                        </TableBody>
                                    </Table>

                                    {!domainLog?.row_logs?.length &&
                                        <div className={`d-flex justify-content-center no-data-found gap-2`}><BackupTableIcon color='primary' /><Typography color='primary'>{domainLog?.status !== "failed" ? "We are processing on data!" : "Something went wrong while processing the file. Please review the file and try again."}</Typography></div>
                                    }
                                </TableContainer>
                                {/* <Button variant='outlined' color='primary' onClick={() => setOpen(false)}>Close</Button> */}
                            </DialogContent>
                            <DialogActions>
                                <Box className="mr-2 mt-2 mb-2" sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button variant="outlined" color="primary" onClick={() => setOpenPreview(false)}>
                                        Close
                                    </Button>
                                </Box>
                            </DialogActions>
                        </Dialog>
                    </Box>
                    <Confirmation open={isOpen} setOpen={setIsOpen} msg={"Are you sure you want to delete this DomainLogLog"} yesClick={() => { handleDelete(domainLog?.uuid); setIsOpen(false) }} />
                </Grid>
            </Grid>
        </>
    )
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
    {
        label: 'File Name',
        numeric: false,
        disablePadding: false,
        id: 'filename',
        sortable: true
    },

    {
        label: 'status',
        numeric: false,
        disablePadding: false,
        id: 'status',
        sortable: true
    },
    {
        label: 'Imported At',
        numeric: false,
        disablePadding: false,
        id: 'imported_at',
        sortable: false
    },
    {
        label: 'Completed At',
        numeric: false,
        disablePadding: false,
        id: 'completed_at',
        sortable: false
    },
    {
        label: 'Actions',
        numeric: true,
        disablePadding: false,
        id: 'actions',
        sortable: false
    },
];
const statusIcons = {
    queued: <AccessTime fontSize="small" className='mr-1' />,
    inProgress: <PlayCircleFilled fontSize="small" className='mr-1' />,
    succeed: <CheckCircle fontSize="small" className='mr-1' />,
    failed: <Cancel fontSize="small" className='mr-1' />,
    skipped: <Stop fontSize="small" className='mr-1' />,
};

function EnhancedTableHead(props) {
    const { setOrdering, orderingState, setOrderingState } =
        props;
    const createSortHandler = (property) => (event) => {
        const orderData = orderingState
        const exists = orderData?.find((item) => item.id === property);
        const updated = (() => {

            if (exists) {
                return orderData.map((item) =>
                    item.id === property
                        ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
                        : item
                );
            } else {
                return [...orderData, { id: property, order: "asc" }];
            }
        })();
        setOrderingState(updated)

    };
    React.useEffect(() => {
        const ordering = orderingState.map((item) => {
            return item.order === "asc" ? item.id : "-" + item.id;
        });
        if (ordering?.length) {
            setOrdering(ordering.join(","));
        }

    }, [orderingState]);

    const removeFilter = (property) => {
        const data = orderingState.filter((item) => item.id !== property)
        setOrderingState(data)
    }
    return (
        <TableHead>
            <TableRow>

                {headCells.map((headCell) => {
                    const key = headCell.id;
                    const sortObj = orderingState.find((item) => item.id === key);
                    const isSorted = !!sortObj;
                    const sortDirection = sortObj?.order || "asc";

                    return (<TableCell
                        className="font-weight"
                        key={key}
                        align={headCell.numeric ? "left" : "left"}
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={isSorted ? sortDirection : false}
                    >
                        {headCell.sortable ? <TableSortLabel
                            active={isSorted}
                            direction={sortDirection}
                            onClick={createSortHandler(key)}
                            color="secondary"
                            hideSortIcon={false}
                        >
                            {headCell.label}
                            {isSorted && (
                                <Box component="span" sx={visuallyHidden}>
                                    {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                                </Box>
                            )}
                            {isSorted && <FilterListOffIcon onClick={(e) => { e.stopPropagation(); removeFilter(headCell.id) }} className="ml-2" size="small" color='primary' />}
                        </TableSortLabel> : headCell.label}
                    </TableCell>)
                })}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { numSelected, theme } = props;
    const industries = useSelector((state) => state.industryReducer.industries)
    const [open, setOpen] = React.useState(false);
    const { selectedIndustry, setSelectedIndustry, domainLogModal, setDomainLogLogModal, selectedDomainLogLog, setSelectedDomainLogLog, setResetTrigger, resetTrigger } = props;
    return (
        <>


            <Toolbar className='main-list-toolbar'>
                <Grid container alignItems="center" spacing={1} className="w-100">
                    <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                        <Typography
                            variant="h6"
                            id="tableTitle"
                            component="div"
                            className="d-flex flex-grow-1"
                        >
                            Import Logs
                        </Typography>
                    </Grid>
                </Grid>


            </Toolbar>

        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default function ImportDomainLogManage() {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [selectedIndustry, setSelectedIndustry] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
    const [domainLogModal, setDomainLogLogModal] = React.useState(false);
    const [selectedDomainLogLog, setSelectedDomainLogLog] = React.useState({});
    const [resetTrigger, setResetTrigger] = React.useState(false);
    const [opneActiveConfirm, setOpneActiveConfirm] = React.useState(false);
    const domainImportLogs = useSelector((state) => state.domainReducer?.domainImportLogs)
    const loading = useSelector((state) => state.domainReducer.loading)
    const count = useSelector((state) => state.domainReducer.importLogCount)
    const userPermission = useSelector((state) => state.userReducer.userPermission)
    const [orderingState, setOrderingState] = React.useState([])
    const [ordering, setOrdering] = React.useState('-updated_at');
    const domianPermissions = userPermission.find((perm) => perm.model_name === "domain")?.permissions || [];
    let canEdit = domianPermissions.includes("change");
    let canDelete = domianPermissions.includes("delete");
    const dispatch = useDispatch()
    const theme = useTheme();


    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const label = { inputProps: { 'aria-label': 'Color switch demo' } };

    const LocationsPreview = ({ locations }) => {
        const [showAll, setShowAll] = React.useState(false);

        if (!locations?.length) return null;

        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {(showAll ? locations : locations.slice(0, 1))?.map((loc) => (
                    <Typography key={loc.id} variant="body2" color="textSecondary">
                        {loc.display_name}
                    </Typography>
                ))}

                {locations.length > 1 && !showAll && (
                    <BasicPopover length={locations.length - 1}>
                        <List disablePadding dense className='location-list'>
                            {locations.slice(1).map((loc, index) => (
                                <ListItem key={index} disableGutters>
                                    <ListItemText
                                        primary={
                                            <Typography color='primary' variant='body2'>{index + 1}. {loc?.display_name}</Typography>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </BasicPopover>
                )}
            </Box>
        );
    };

    React.useEffect(() => {
        const rowData = domainImportLogs?.map((ele) => {
            const underscoreIndex = ele?.filename.lastIndexOf('_');
            const dotIndex = ele?.filename.lastIndexOf('.');
            const cleanedFilename = ele.filename.substring(0, underscoreIndex) + ele.filename.substring(dotIndex);

            return createData(ele?.id, cleanedFilename, ele?.uploaded_file, ele?.status, ele?.imported_at, ele?.completed_at,
                <DomainLogActions {...{ theme, domainLogModal, setDomainLogLogModal, setSelectedDomainLogLog, canDelete, canEdit }} domainLog={ele} />)
        })
        setRows(rowData)
    }, [domainImportLogs, loading])

    // const visibleRows = React.useMemo(() => {
    //     if (rows?.length) {
    //         return [...rows]
    //     }
    // }, [rows]);

    function Row(props) {
        const [open, setOpen] = React.useState(false)
        const { row, labelId } = props;
        const color = theme.palette.custom?.[row?.status];
        const bgColor = theme.palette.custom?.[`${row?.status}Background`];
        const borderColor = theme.palette.custom?.[`${row?.status}Border`];

        return (
            <React.Fragment>
                <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.id}
                    id={labelId}
                    className='cursor-pointer'
                >
                    <TableCell align="left">{row.fileName || "N/A"}</TableCell>
                    {/* <TableCell align="left">
                        <Button color='primary' size='small' variant="outlined" onClick={() => { setOpen(true) }}>   Preview File</Button>
                    </TableCell> */}
                    <TableCell align="left">
                        <Button
                            size="small"
                            sx={{
                                color: color || 'inherit',
                                backgroundColor: bgColor ? alpha(bgColor, 0.1) : 'transparent',
                                borderColor: borderColor || 'grey.300',
                                textTransform: 'capitalize',
                            }}
                            variant="outlined"
                        >
                            {statusIcons[row?.status]}
                            {row?.status}
                        </Button>
                    </TableCell>
                    <TableCell align="left">{formatDate(row.importedAt)}</TableCell>
                    <TableCell align="left">{formatDate(row.completedAt) || "In Progress"}</TableCell>
                    <TableCell align="left">{row.actions}</TableCell>
                </TableRow>

            </React.Fragment >
        );
    }
    useEffect(() => {
        dispatch(fetchDomainImportLogs(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering}`))
    }, [ordering, page, rowsPerPage])

    return (
        <Box className='w-100'>
            <Confirmation open={opneActiveConfirm} setOpen={setOpneActiveConfirm} msg={"Are you sure you want to Inactive this DomainLogLog"} yesClick={() => { ; setOpneActiveConfirm(false) }} />
            <Paper className="w-100 mb-2" >
                <EnhancedTableToolbar numSelected={selected.length} {...{ theme, selectedIndustry, setSelectedIndustry, domainLogModal, setDomainLogLogModal, setSelectedDomainLogLog, selectedDomainLogLog, setResetTrigger, resetTrigger }} />
                {loading && <LinearProgress />}
                <TableContainer className='position-relative'>
                    <Table
                        className='min-width-750'
                        aria-labelledby="tableTitle"
                        size={'small'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            orderingState={orderingState}
                            setOrderingState={setOrderingState}
                            setOrdering={setOrdering}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows?.length}
                        />
                        <TableBody>
                            {rows?.map((row, index) => {
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <Row row={row} label={labelId} />
                                );
                            })}
                        </TableBody>
                    </Table>
                    {!domainImportLogs?.length && !loading && <NoData></NoData>}
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    );
}
